export default {
  sm: `
  데이터센터 각 브랜드 마크   
  `,
  lg: `
  데이터센터 각
  브랜드 마크
  `
};
